<template>
  <div id="investor-edit-view" class="data-list-container">
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs class="tab-action-btn-fill-conatiner">
          
          <vs-tab :label="$t('MainInfo')" icon-pack="feather" icon="icon-info">
            <div class="tab-text">
              <MainData class="mt-4" :Investor="Investor" />
            </div>
          </vs-tab>

          <vs-tab :label="$t('PurchaseOrders')" icon-pack="feather" icon="icon-image">
            <div class="tab-text">
              <InvestorPurchaseOrders class="mt-4" :Investor="Investor" />
            </div>
          </vs-tab>

        

        </vs-tabs>
      </div>
    </vx-card>
    
  </div>
</template>

<script>
import MainData from "./MainData.vue";
import InvestorPurchaseOrders from "./InvestorPurchaseOrders.vue";
import moduleInvestors from "@/store/Investors/moduleInvestors.js";
import moduleNationalities from "@/store/Nationality/moduleNationalities.js";
export default {
  components: {
    MainData,
    InvestorPurchaseOrders


  },
  data() {
    return {
      user_not_found: false,

    Investor: {}

    };
  },
  computed: {


  },
  methods: {
   
    cancel() {
      this.$router.go(-1);
    },
  },
  created() {
    
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    
    if (!moduleInvestors.isRegistered) {
      this.$store.registerModule("InvestorsList", moduleInvestors);
      moduleInvestors.isRegistered = true;
    }
   

    const ID = this.$route.params.ID;

    if (ID != undefined && ID != 0) {
      this.$store
        .dispatch("InvestorsList/GetItemByID", ID)
        .then((res) => {
         this.Investor = res.data.Data;
         
        })
        .catch((err) => {
          this.$vs.notify({
            title: this.$t("Error"),
            text: err.response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
          // }
          this.$vs.loading.close();
        });
    } else if (ID == undefined) {
      ID == 0;
    }
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>


<style lang="scss">

#data-list-list-view small {
  color: rgb(255, 115, 0);
  text-decoration: underline rgb(255, 115, 0);
}

vs-input {
  height: 37px;
}

datepicker {
  height: 37px;
}

.chk {
  height: 20px;
  width: 50px;
  margin-top: 30px;
}

.vxCard:after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0%;
  margin-left: 10%;
  z-index: 500000;
  width: 25%;
  height: 20%;
  border-top: 3px solid rgb(255, 115, 0) !important;
  border-bottom: 0 none rgba(255, 0, 0, 0.9) !important;
  border-right: 0 none rgba(255, 0, 0, 0.9) !important;
  border-left: 0 none rgba(0, 0, 0, 0.9) !important;
}

#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
